<div class="section-empty" [class.section-empty--inline]="preset() === 'inline'">
  <div class="section-empty__content">
    @if (icon()) {
      <cm-icon
        [name]="icon()"
        [color]="iconColor()"
        [size]="preset() === 'inline' ? 'md' : 'lg'"
      />
    }

    <span class="section-empty__title">{{ title() }}</span>

    @if (subtitle()) {
      <p class="section-empty__subtitle">{{ subtitle() }}</p>
    }

    @if (buttonLabel()) {
      <div class="section-empty__actions">
        <cm-button
          variant="flat"
          color="primary"
          [loading]="buttonLoading()"
          (click)="onCreateClick()">
          @if (buttonIcon()) {
            <cm-icon [name]="buttonIcon()" mode="fill" size="md" />
          }
          {{ buttonLabel() }}
        </cm-button>
      </div>
    }
  </div>
</div>
